import { Link, useLocation } from '@tanstack/react-router';
import { Logo } from '@/components/layout/logo';
import { MobileNav } from '@/components/layout/mobile-nav';
import { SearchInput } from '@/components/layout/search-input';
import { ThemeToggle } from '@/components/layout/theme-toggle';
import { UserMenu } from '@/components/layout/user-menu';
import { getNavItems } from '@/lib/nav-items';
import { cn } from '@/lib/utils';

export function Header() {
  const location = useLocation();
  const navItems = getNavItems();
  const currentPath = location.pathname + (location.searchStr || '');

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 shadow-sm backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="mx-auto my-2 flex w-full max-w-screen-2xl items-center px-2 pe-2">
        <div className="me-4 flex md:w-full">
          <MobileNav />
          <Logo />
          <nav className="hidden items-center justify-center text-sm font-medium md:flex md:w-full md:me-2">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={cn(
                  'flex h-full items-center rounded-md px-3 text-center text-xs text-foreground/60 transition-colors hover:bg-accent hover:text-foreground/80 md:text-sm',
                  currentPath === item.href && 'bg-accent',
                )}
              >
                {item.title}
              </Link>
            ))}
          </nav>
        </div>
        <div className="flex flex-1 items-center justify-end">
          <SearchInput />
          <ThemeToggle />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
